//TODO: if necessary, optimize to only search necessary tags based on action type
const tagTypes = ['h2', 'h4', 'p', 'li', 'span', 'div']; //other tag types may need to be added for new actions
const invisibleChar = '‌‌'; //Don't modify! There really is an invisible character between the quotations!

export function colorPlaceholderText() {
	tagTypes.forEach(type => {
		const elements = [...document.querySelectorAll(type)];
		elements.forEach(el => {
			if (el.textContent.slice(0,2) === invisibleChar) el.style.color = '#c9c3c3';
			else el.style.color = null; //note: element should have a non-inline default color set
		});
	});
}
